import { render, staticRenderFns } from "./DropPlainFile.vue?vue&type=template&id=3d468086&scoped=true"
import script from "./DropPlainFile.vue?vue&type=script&lang=js"
export * from "./DropPlainFile.vue?vue&type=script&lang=js"
import style0 from "./DropPlainFile.vue?vue&type=style&index=0&id=3d468086&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d468086",
  null
  
)

export default component.exports